import { isHttpSecure } from "lib/utils/utils";
import { gatewayServiceBaseUrl } from "lib/consts/arcGateway";

/** HTTP progress server on the ARC (r2c2_aurora progress_server.py, uvicorn). */
const DEFAULT_MAP_PROGRESS_PORT = "12396";

/**
 * Base URL for map save/load progress (GET /progress). Disabled when null.
 * Uses the same host resolution pattern as STCM map list unless overridden.
 */
export function getMapProgressBaseUrl(arcHost?: string | null, isSecure: boolean = isHttpSecure(), arcId?: string | null): string | null {
    if (process.env.REACT_APP_MAP_PROGRESS_DISABLED === "true") {
        return null;
    }
    const explicit = process.env.REACT_APP_MAP_PROGRESS_BASE_URL?.trim();
    if (explicit) {
        return explicit.replace(/\/$/, "");
    }
    const port =
        process.env.REACT_APP_MAP_PROGRESS_PORT?.trim() || DEFAULT_MAP_PROGRESS_PORT;
    const host =
        process.env.REACT_APP_MAP_PROGRESS_HOST?.trim() ||
        arcHost?.trim() ||
        process.env.REACT_APP_SINGLE_ARC_HOSTNAME?.trim() ||
        process.env.REACT_APP_HOST_OVERRIDE?.trim() ||
        (typeof window !== "undefined" ? window.location.hostname : "");
    if (!host) {
        return null;
    }
    const protocol = isSecure ? "https" : "http";
    // Direct mode uses arc_gateway; fleet mode uses the proxy's path-routed
    // origin. A fleet ARC without a proxy host is unavailable.
    const gatewayBase = gatewayServiceBaseUrl("mapProgress", arcId, arcHost);
    if (gatewayBase) return gatewayBase;
    if (arcId) return null;

    return `${protocol}://${host}:${port}`;
}
